export const apportionmentMessages = {
	// Mensagens de seleção/input
	MSG_SELECT_START_MONTH: 'Selecione o mês de início',
	MSG_SELECT_END_MONTH: 'Selecione o mês final',
	MSG_SELECT_PLAN_CYCLE_YEAR:
		'Selecione o ciclo e ano do plano para o rateio',
	MSG_NO_BASE_SELECTED: 'Selecione uma base de distribuição: ',
	MSG_TOOLTIP_SELECT_BASE: 'Selecione a base desejada',
	MSG_INFORM_START_END_DATE:
		'Informe a data de início e fim que deseja considerar na distribuição do rateio.',
	MSG_INFORM_CYCLE_AND_YEAR:
		'Informe o ciclo e ano do plano que deseja considerar na distribuição do rateio.',

	// Dicas e sugestões
	MSG_TIP_USE_SALES_HISTORY:
		'Se estiver em dúvida, sugerimos utilizar o histórico de vendas.',
	MSG_TIP_USE_LAST_12_MONTHS:
		'Se estiver em dúvida, sugerimos usar os últimos 12 meses.',
	MSG_TIP_USE_MOST_RECENT_PLAN:
		'Se estiver em dúvida, sugerimos usar o plano mais recente.',

	// Mensagens de validação
	MSG_CURRENT_MONTH_NOT_ALLOWED: 'O mês atual não pode ser utilizado.',
	MSG_START_MONTH_GREATER_THAN_END:
		'O mês inicial não pode ser maior que o mês final.',
	MSG_NO_BASE_SELECTED_ERROR: 'não definida',
	MSG_NO_SALES_IN_PERIOD:
		'Não existem vendas cadastradas para os meses selecionados.',
	MSG_NO_RECORDS_FOUND:
		'Nenhum registro encontrado para o ciclo selecionado.',

	// Mensagens de erro
	MSG_LOAD_DEFAULT_SETUP_ERROR: 'Erro ao carregar configuração padrão:',
	MSG_LOAD_DEFAULT_CYCLE_ERROR: 'Erro ao carregar ciclo padrão.',
	MSG_SEARCH_PLANS_ERROR: 'Erro ao buscar planos disponíveis.',
	MSG_SAVE_CONFIG_ERROR: 'Erro ao salvar configuração.',

	// Mensagens de sucesso
	MSG_PLAN_DISTRIBUTED_SUCCESS: 'Planejamento distribuído com sucesso!',
	MSG_PLAN_DISTRIBUTED_ERROR: 'Erro ao distribuir planejamento.',
	MSG_SAVE_CONFIG_SUCCESS: 'Configuração salva com sucesso!',

	// Mensagens informativas/confirmacao
	MSG_QUESTION_WHICH_APPORTIONMENT_TO_SAVE_PLANNING:
		'Deseja salvar o planejamento distribuindo por qual rateio?',
	MSG_INFO_PLAN_WILL_BE_SAVED_AT_MOST_DETAILED_LEVEL:
		'O plano será salvo no nível mais detalhado. Os itens selecionados serão distribuídos até o menor nível das hierarquias, conforme o período de rateio escolhido.',
	MSG_SAVE_AS_DEFAULT_NO_PROMPT:
		'Salvar esta escolha como padrão e não perguntar novamente',

	// Mensagens para base zerada
	MSG_ZERO_APPORTIONMENT_TITLE:
		'Notamos que a base de distribuição do rateio selecionada está zerada!',
	MSG_ZERO_APPORTIONMENT_OPTION_OTHER_BASE:
		'Selecionar outra base de distribuição do rateio',
	MSG_ZERO_APPORTIONMENT_OPTION_EQUAL:
		'Distribuir igualmente para todos os itens (todos os produtos da hierarquia selecionada)',
	MSG_ZERO_APPORTIONMENT_OPTION_MANUAL:
		'Salvar zerado e editar posteriormente o plano de forma manual',

	// Mensagens do Planning - Mesmo Mês do Ano Anterior
	MSG_PLANNING_PREVIOUS_YEAR_NO_DATA_TITLE: 'Erro ao buscar dados',
	MSG_PLANNING_PREVIOUS_YEAR_NO_DATA_DESCRIPTION:
		'Sem dados de vendas para os filtros selecionados.',
	MSG_PLANNING_PREVIOUS_CYCLE_NO_DATA_DESCRIPTION:
		'Sem dados de planejamento para os filtros selecionados.',
};
